import React from 'react';
import styles from './WelcomeComponent.module.css';


const WelcomeComponent = () => {

return (
    <div className={styles.welcomeContainer}>
      <section className={styles.hero}>
        <h2 className={styles.title}>Bienvenido a la API para Emarsys</h2>
        <p className={styles.subtitle}>
          Integra, envía y gestiona tus campañas de Emarsys rápida y fácilmente.
        </p>
        <div className={styles.actions}>
          <a href="#docs" className={styles.btnPrimary}>
            Ver documentación
          </a>
          <a href="#quickstart" className={styles.btnSecondary}>
            Probar endpoint
          </a>
        </div>
      </section>

      <footer className={styles.footer}>
        © {new Date().getFullYear()} API para Emarsys ·
        <a href="#github">GitHub</a>
      </footer>
    </div>
  );
};

export default WelcomeComponent;
